"use client";
import { FC } from "react";
import { formatNumber } from "@repo/shared-utils/num-utils";
import BFLLink from "@repo/shared-ui/BFLLink";
import BFLImage from "@repo/shared-ui/BFLImage";
import { ISimilarStockData } from "../../interfaces/SimilarStocks.interface";
import { addStash } from "@repo/shared-utils/common-utils";

interface StockCardProps {
  stock: ISimilarStockData;
  defaultImage?: string;
}

const StockCard: FC<StockCardProps> = ({ stock, defaultImage }) => {
  if (!stock) {
    return null;
  }

  const { compName, ltp, chgPer, logo, redirectURL } = stock;
  const isPositive = chgPer >= 0;

  return (
    <BFLLink
      href={addStash(redirectURL)}
      className="block h-[172px] w-[138px] rounded-lg border border-gray-300"
      openInNewTab={true}
    >
      <span className="flex h-12 w-full items-center justify-center border-b border-gray-300">
        <BFLImage
          src={logo ?? defaultImage}
          alt="logo"
          width={48}
          height={48}
          unoptimized={true}
        />
      </span>
      <span className="mt-3 flex h-[112px] flex-col gap-2 px-[9px] pb-[9px]">
        <p className="font-400 line-clamp-2 h-12 overflow-hidden text-ellipsis text-base capitalize leading-6">
          {compName?.toLowerCase() ?? ""}
        </p>
        <div className="">
          <h4 className="font-medium leading-[18.96px]">
            {"₹"+formatNumber(ltp, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
          </h4>
          <div
            className={`positive flex w-max items-center gap-[4.75px] rounded-[6px] bg-${isPositive ? "green-100" : "red-100"} p-1 ${isPositive ? "text-green-500" : "text-red-600"}`}
          >
            <p className="text-base leading-[18.96px]">
              {isPositive ? "▲" : "▼"} {Math.abs(chgPer).toFixed(2)+"%"}
            </p>
          </div>
        </div>
      </span>
    </BFLLink>
  );
};

export default StockCard;
